// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}
.amplify-icon > svg {
  height: var(--amplify-components-icon-height);
  width: var(--amplify-components-icon-height);
  display: none;
  border: none !important;
}

.amplify-liveness-cancel-button {
  background-color: #fff;
  color: hsl(190, 95%, 30%);
  display: none !important;
  border: none !important;
}
button#popover-button {
  border: none;
}
/* @media (max-width: 768px) {
.amplify-liveness-toast--primary .amplify-liveness-toast__message {
    color: var(--amplify-colors-font-inverse);
    text-align: center;
    flex-direction: column;
    display: none;
  }
} */

/* @media (max-width: 768px) {
  .amplify-liveness-toast__message:has(> span:contains("Center your face")) {
    display: none !important;
  }
} */
@media (max-width: 768px) {
  .amplify-liveness-toast__message div[aria-live] {
    font-size: 14px !important;
    /* display: none !important; */
  }

}
@media (max-width: 600px) {
  .css-1kx3dis-MuiGrid-root {
    margin: 0px !important;
  }
}
@media (max-width: 600px) {
  .css-1246g0t-MuiPaper-root-MuiAlert-root {
    padding-left: 2px !important;
    padding-right: 2px !important;
  }
  .amplify-alert__body {
    color: inherit;
    display: block;
    font-size: 12px !important;
  }
  .css-vwhg53 {
    padding-top: 10px !important;
  }
  .amplify-liveness-popover {
    position: relative;
    display: none !important;
  }
  .initiate-root {
    padding: 5px !important;
  }
  .css-122jq7f-MuiStepLabel-root {
    padding: 0px 0px !important;
  }
  .amplify-liveness-overlay {
    align-items: center !important;
    justify-content: center !important;
  }
  .amplify-liveness-oval-canvas {
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
  }
  .amplify-flex.liveness-detector-check {
    gap: 0 !important;
  }
}
@media screen and (min-width: 1024px) {
  button.amplify-button.amplify-field-group__control.amplify-button--primary {
    margin-top: -30px;
  }
}
.facelivenessdetector {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  text-align: center;
}
.amplify-liveness-toast--primary .amplify-liveness-toast__message {
  color: var(--amplify-colors-font-inverse);
  text-align: center;
  flex-direction: column;
  font-size: 19px !important; 
}

.amplify-liveness-overlay {
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}

/* button.amplify-button.amplify-field-group__control.amplify-button--primary {
  padding-top:2px;
  padding-bottom:2px;

} */

/* .image-preview {
    height: 30vh;
    overflow-y: scroll;
      scrollbar-width: 5px!important;          
  scrollbar-color: #670b4e #f1f1f1!important;   
} */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA;EACE,6CAA6C;EAC7C,4CAA4C;EAC5C,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;;;;;;;GAOG;;AAEH;;;;GAIG;AACH;EACE;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;;AAEF;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,cAAc;IACd,cAAc;IACd,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;IAC9B,kCAAkC;EACpC;EACA;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,oBAAoB;IACpB,2CAA2C;EAC7C;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;;;GAIG;;AAEH;;;;;GAKG","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n.amplify-icon > svg {\n  height: var(--amplify-components-icon-height);\n  width: var(--amplify-components-icon-height);\n  display: none;\n  border: none !important;\n}\n\n.amplify-liveness-cancel-button {\n  background-color: #fff;\n  color: hsl(190, 95%, 30%);\n  display: none !important;\n  border: none !important;\n}\nbutton#popover-button {\n  border: none;\n}\n/* @media (max-width: 768px) {\n.amplify-liveness-toast--primary .amplify-liveness-toast__message {\n    color: var(--amplify-colors-font-inverse);\n    text-align: center;\n    flex-direction: column;\n    display: none;\n  }\n} */\n\n/* @media (max-width: 768px) {\n  .amplify-liveness-toast__message:has(> span:contains(\"Center your face\")) {\n    display: none !important;\n  }\n} */\n@media (max-width: 768px) {\n  .amplify-liveness-toast__message div[aria-live] {\n    font-size: 14px !important;\n    /* display: none !important; */\n  }\n\n}\n@media (max-width: 600px) {\n  .css-1kx3dis-MuiGrid-root {\n    margin: 0px !important;\n  }\n}\n@media (max-width: 600px) {\n  .css-1246g0t-MuiPaper-root-MuiAlert-root {\n    padding-left: 2px !important;\n    padding-right: 2px !important;\n  }\n  .amplify-alert__body {\n    color: inherit;\n    display: block;\n    font-size: 12px !important;\n  }\n  .css-vwhg53 {\n    padding-top: 10px !important;\n  }\n  .amplify-liveness-popover {\n    position: relative;\n    display: none !important;\n  }\n  .initiate-root {\n    padding: 5px !important;\n  }\n  .css-122jq7f-MuiStepLabel-root {\n    padding: 0px 0px !important;\n  }\n  .amplify-liveness-overlay {\n    align-items: center !important;\n    justify-content: center !important;\n  }\n  .amplify-liveness-oval-canvas {\n    position: absolute !important;\n    top: 50% !important;\n    left: 50% !important;\n    transform: translate(-50%, -50%) !important;\n  }\n  .amplify-flex.liveness-detector-check {\n    gap: 0 !important;\n  }\n}\n@media screen and (min-width: 1024px) {\n  button.amplify-button.amplify-field-group__control.amplify-button--primary {\n    margin-top: -30px;\n  }\n}\n.facelivenessdetector {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100%;\n  text-align: center;\n}\n.amplify-liveness-toast--primary .amplify-liveness-toast__message {\n  color: var(--amplify-colors-font-inverse);\n  text-align: center;\n  flex-direction: column;\n  font-size: 19px !important; \n}\n\n.amplify-liveness-overlay {\n  padding-top: 1px !important;\n  padding-bottom: 1px !important;\n}\n\n/* button.amplify-button.amplify-field-group__control.amplify-button--primary {\n  padding-top:2px;\n  padding-bottom:2px;\n\n} */\n\n/* .image-preview {\n    height: 30vh;\n    overflow-y: scroll;\n      scrollbar-width: 5px!important;          \n  scrollbar-color: #670b4e #f1f1f1!important;   \n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
